import { Box, SxProps, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FlaskIcon } from 'src/assets/icons/v2/FlaskIcon'

interface IProps {
  sx?: SxProps
}

export const AIGeneratedBanner = ({ sx }: IProps) => {
  const [t] = useTranslation()
  const theme = useTheme()
  return (
    <Box
      id="index__components-ai-generated-banner__box__l9"
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        height: '22px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '4px 4px 0px 0px',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        ...sx,
      }}
    >
      <Typography
        id="index__components-ai-generated-banner__typography__l25"
        sx={{
          fontSize: '10px',
          fontWeight: 700,
          color: theme.palette.common.white,
          mt: '2px',
        }}
        textAlign={'center'}
      >
        {t('ai-generated-label')}
      </Typography>
      <FlaskIcon size={14} />
    </Box>
  )
}
